import { render, staticRenderFns } from "./CompetencesCreate.vue?vue&type=template&id=fe8f3418&scoped=true"
import script from "./CompetencesCreate.vue?vue&type=script&lang=js"
export * from "./CompetencesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8f3418",
  null
  
)

export default component.exports